const endpoints = {
  me: '/v2/members/me',
  refresh: '/v2/users/auth/refresh',
  authenticate: '/v2/users/authenticate',
  passwordReset: '/v2/users/password/reset'
};

export default endpoints;



/** WEBPACK FOOTER **
 ** ./src/constants/endpoints.js
 **/